import * as React from 'react';
import * as ProductEditStore from '@/redux/pages/product-edit';

import { connect } from 'react-redux';

import store from '@/redux';
import { parse } from 'query-string';

const Toast = require('react-toast-mobile');

class ProductPerformance extends React.Component<any, any> {
    private activeIndex: number = 0;
    constructor(props: any) {
        super(props);
        this.state = {
            visible: false, // 显示弹窗
            text: '', // 输入内容
            source: parse(this.props.location.search).source
        };
    }
    public render() {
        const state = this.state;
        const props = this.props;
        return(
            <section className="expert-edit place">
                <div className="ylk-edit-wrapper margin-0">
                    {
                        props.performance.map((v: string, k: number) => { 
                            return (
                                <div className="expert-edititem" onClick={() => this.edit(k)} key={k}>
                                    <div className="expert-editgroup">
                                        <p className={`text-left ${v ? 'active' : ''}`}>{v ? '已填写' : '请填写'}</p>
                                        <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" />
                                    </div>
                                </div>
                            )
                        })
                    }
                    
                </div>
                {
                    this.state.source !== '4' ?
                    <div className="expert-editbottom">
                            <button className="btn-default" onClick={() => this.add()}>添加</button>
                            <button className="btn-submit" onClick={() => this.back()}>确定</button>
                    </div> : null
                }               
                <div className={`performance-popup ${state.visible ? 'active' : ''}`}>
                    <div className="performance-popupc">
                        <i onClick={() => this.popupClose()}>&times;</i>
                        <strong>添加性能特点</strong>
                        <textarea placeholder="请输入性能特点..." value={state.text} onChange={() => this.inputAction()} readOnly={this.state.source === '4'}></textarea>
                        {
                            this.state.source !== '4' ?
                            <div className="performance-btns">
                                {
                                    this.activeIndex > 0 ? <p onClick={() => this.popupDel()}>删除</p> : null
                                }
                                <p onClick={() => this.popupSave()}>保存</p>
                            </div> : null
                        }
                    </div>
                </div>
            </section>
        )
    }

    /**
     * 编辑
     * @param index {number} 编辑第几个
     */
    private edit(index: number) { 
        this.activeIndex = index;
        this.setState({
            text: this.props.performance[index],
            visible: true
        });
    }
    
    // 添加一个
    private add() { 

        if (this.props.performance.length > 4) { 
            return Toast.T.notify('最多只能添加5个性能特点');
        }

        const temp = this.props.performance;
        temp.push('');
        store.dispatch({
            type: ProductEditStore.types.INPUT,
            data: {
                key: 'performance',
                value: temp
            }
        });

    }

    // 确定
    private back() { 
        this.props.history.goBack();
    }

    // 关闭弹层
    private popupClose() { 
        this.setState({
            text: '',
            visible: false
        });
    }

    // 删除
    private popupDel() {

        const temp = this.props.performance;
        temp.splice(this.activeIndex, 1);
        store.dispatch({
            type: ProductEditStore.types.INPUT,
            data: {
                key: 'performance',
                value: temp
            }
        });

        this.popupClose();

    }

    // 保存
    private popupSave() {

        if (this.state.text === '') {
            return Toast.T.notify('请输入性能特点');
        } else if (this.state.text.length > 4000) { 
            return Toast.T.notify('性能特点最多只能4000字');
        }

        const temp = this.props.performance;
        temp[this.activeIndex] = this.state.text;
        store.dispatch({
            type: ProductEditStore.types.INPUT,
            data: {
                key: 'performance',
                value: temp
            }
        });

        this.popupClose();

    }

    // 输入
    private inputAction() { 
        this.setState({
            text: (event as any).target.value
        });
    }
}

const mapStateToProps = (state: any): ProductEditStore.IProductEditState => { 
    return {
        ...state.productEditReducers
    }
}

export default connect(mapStateToProps)(ProductPerformance);